
import type { PropType } from 'vue';

import { defineComponent } from 'vue';

import type { GenericObject } from '@/types';

export default defineComponent({
  props: {
    statisticsFilters: {
      type: Object as PropType<GenericObject>,
      required: true,
    },
    filters: {
      type: Object as PropType<GenericObject>,
      required: true,
    },
    hideRequestsColumn: {
      type: Boolean,
      default: false,
    },
    hideFeedsRequestsColumn: {
      type: Boolean,
      default: false,
    },
    hideFeedsPayoutColumn: {
      type: Boolean,
      default: false,
    },
    showExtraData: {
      type: Boolean,
      default: false,
    },
    iconSize: {
      type: Number,
      required: true,
    },
  },
});
